var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-button"},[_c('a',{staticClass:"cx-link",attrs:{"target":"_blank","href":_vm.mapURL}},[(!_vm.hideIcon)?_c('span',{staticClass:"cx-link__icon"},[_c('i',{staticClass:"fal fa-map"})]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.text || _vm.$t(`media.${ _vm.mapToUse }`)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }